import { useEffect, useState } from "react";

const getFormatedDelay = (time) => {
  const seconds = Math.floor((time / 1000) % 60)
  const minutes = Math.floor((time / (1000 * 60)) % 60)
  const hours = Math.floor((time / (1000 * 60 * 60)) % 24)
  const days = Math.floor(time / (1000 * 60 * 60 * 24))

  return {
    days: String(days).padStart(2, '0'),
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0')
  }
}

const getNextTargetDate = () => {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth() + 1, 1);
}

export const useTimer = () => {
  const [targetDate] = useState(getNextTargetDate())
  const [timeLeft, setTimeLeft] = useState({ days: "00", hours: "00", minutes: "00", seconds: "00" });

  useEffect(() => {
    const tick = () => {
      const now = new Date()

      const delay = targetDate - now

      setTimeLeft(getFormatedDelay(delay))
    }

    tick()

    const intervalId = setInterval(tick, 1000)

    return () => clearInterval(intervalId)
  }, [targetDate])

  const formattedTargetText = targetDate.toLocaleDateString("de-DE", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return { timeLeft, formattedTargetText }
}